import {IPlannerPropertyRoomType} from "../../types/planner_property/IPlannerPropertyRoomType";
import {IPlannerRoomNames} from "../../types/planner_property/IPlannerRoomNames";

export const isKitchen = (roomType: IPlannerPropertyRoomType) => {
    return roomType === IPlannerPropertyRoomType.Kitchen;
};

export const isLivingRoom = (roomType: IPlannerPropertyRoomType, roomName: string) => {
    return (
        roomType === IPlannerPropertyRoomType.Room &&
        (roomName.toLowerCase() === IPlannerRoomNames.LivingRoom || roomName.toLowerCase() === IPlannerRoomNames.LivingRoomWithKitchenette)
    );
};

export const isBedroom = (roomType: IPlannerPropertyRoomType, roomName: string) => {
    return roomType === IPlannerPropertyRoomType.Room && roomName.toLowerCase() === IPlannerRoomNames.Bedroom;
};

export const isBathroom = (roomType: IPlannerPropertyRoomType) => {
    return roomType === IPlannerPropertyRoomType.Bathroom;
};
import {IPlannerPropertyRoomType} from "../../types/planner_property/IPlannerPropertyRoomType";
import {IPlannerRoomNames} from "../../types/planner_property/IPlannerRoomNames";

export const isKitchen = (roomType: IPlannerPropertyRoomType) => {
    return roomType === IPlannerPropertyRoomType.Kitchen;
};

export const isLivingRoom = (roomType: IPlannerPropertyRoomType, roomName: string) => {
    return (
        roomType === IPlannerPropertyRoomType.Room &&
        (roomName.toLowerCase() === IPlannerRoomNames.LivingRoom || roomName.toLowerCase() === IPlannerRoomNames.LivingRoomWithKitchenette)
    );
};

export const isBedroom = (roomType: IPlannerPropertyRoomType, roomName: string) => {
    return roomType === IPlannerPropertyRoomType.Room && roomName.toLowerCase() === IPlannerRoomNames.Bedroom;
};

export const isBathroom = (roomType: IPlannerPropertyRoomType) => {
    return roomType === IPlannerPropertyRoomType.Bathroom;
};
